import { Spin } from 'antd'

export default props => {
  return (
    <div className='text-center my-30'>
      <Spin tip='加载中…' />
    </div>
  )
}
